<template>
  <form action="" method="post" class="account-settings" @submit.prevent>
    <div v-if="serrCallout" class="row">
      <div class="column small-12">
        <Callout
          type="warning"
          :title="serrCallout.title"
          :icon-url="warningIconUrl"
        >
          <template #message>
            {{ serrCallout.lead }}
            <span v-for="label in serrCallout.missingFieldLabels" :key="label">
              <br />
              &bull; {{ label }}
            </span>
          </template>
        </Callout>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mbm">
          <strong class="text-black">Mon portefolio</strong>
          <br />
          <a :href="portfolioUrl" class="overflow-break-text">{{
            portfolioUrl
          }}</a>
          <input type="hidden" name="portfolioUrl" :value="portfolioUrl" />
        </label>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mbm">
          <strong class="text-black">Email</strong>
          <br />
          <span>{{ email }}</span>
          <input type="hidden" name="Email" :value="email" />
        </label>
      </div>
    </div>
    <div class="row">
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Prénom</strong>
          <input
            v-model="firstNameValue"
            class="mts"
            type="text"
            name="FirstName"
            maxlength="50"
          />
        </label>
        <div v-if="form.errors.firstName" class="small-12">
          <ul
            v-for="(error, index) in form.errors.firstName"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Nom de famille</strong>
          <input
            v-model="lastNameValue"
            class="mts"
            type="text"
            name="LastName"
            maxlength="50"
          />
        </label>
        <div v-if="form.errors.lastName" class="small-12">
          <ul
            v-for="(error, index) in form.errors.lastName"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="resendVerificationEmailEndpoint" class="row">
      <div class="column small-12">
        <strong class="text-black">Renvoyer l'e-mail de vérification</strong>
        <br />
        <button
          :disabled="verificationEmailReSent"
          class="button secondary tiny hollow mts"
          @click="resendVerificationEmail"
        >
          Renvoyer
        </button>
        <div v-if="form.errors.resendVerficationEmail" class="small-12">
          <ul
            v-for="(error, index) in form.errors.resendVerficationEmail"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-if="!isChangePasswordFormVisible" class="column small-12">
        <strong class="text-black">Mot de passe</strong>
        <br />
        <button
          class="button secondary tiny hollow mts"
          @click="showChangePasswordForm"
        >
          Changer le mot de passe
        </button>
      </div>
      <div v-if="isChangePasswordFormVisible" class="column small-12">
        <div class="row small-up-1 medium-up-2 large-up-3">
          <div class="column">
            <label>
              <strong class="text-black">Mot de passe actuel</strong>
              <input
                v-model="password"
                class="input-type input-type--password mts"
                type="password"
                name="currentPassword"
                placeholder="Mot de passe actuel"
              />
            </label>
          </div>
          <div class="column">
            <label>
              <strong class="text-black">Nouveau mot de passe</strong>
              <input
                v-model="newPassword"
                class="input-type input-type--password mts"
                type="password"
                name="newPassword"
                placeholder="Nouveau mot de passe"
              />
            </label>
          </div>
          <div class="column">
            <label>
              <strong class="text-black">Confirmer le nouveau mot de passe</strong>
              <input
                v-model="confirmPassword"
                class="input-type input-type--password mts"
                type="password"
                name="confirmPassword"
                placeholder="Confirmer le nouveau mot de passe"
              />
            </label>
          </div>
        </div>
        <div class="row align-center">
          <div class="column shrink">
            <span v-if="showPasswordWarning" class="text-color-red text-small">
              Votre nouveau mot de passe et votre mot de passe de confirmation ne correspondent pas
            </span>
          </div>
        </div>
        <div class="form-stacking mbm">
          <div class="row align-center">
            <div class="column small-12 medium-shrink">
              <button
                class="button secondary hollow form-stacking__item"
                @click="hideChangePasswordForm"
              >
                Annuler
              </button>
            </div>
            <div class="column small-12 medium-shrink">
              <button
                class="button form-stacking__item"
                @click="onSubmitUpdatePasswordForm"
              >
                Changez de mot de passe
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isAustralian" class="row">
      <div class="column small-12">
        <label>
          <strong class="text-black">
            Entity Type
            <img
              ref="js-entity-type-tooltip"
              class="has-tip top mls"
              data-tooltip
              aria-haspopup="true"
              data-allow-html="true"
              data-tooltip-class="tooltip"
              :src="questionIconUrl"
              alt="question mark icon"
              title="Whether you are an individual designer or a registered business."
            />
          </strong>
        </label>
        <div class="row mts">
          <div class="column shrink">
            <label>
              <input
                v-model="entityTypeValue"
                type="radio"
                value="Individual"
              />
              Individual
            </label>
          </div>
          <div class="column shrink">
            <label>
              <input
                v-model="entityTypeValue"
                type="radio"
                value="NonIndividual"
              />
              Business
            </label>
          </div>
        </div>
        <div v-if="form.errors.entityType" class="small-12">
          <ul
            v-for="(error, index) in form.errors.entityType"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Téléphone</strong>
          <input
            v-model="phoneValue"
            class="mts"
            type="text"
            name="Phone"
            maxlength="50"
          />
        </label>
      </div>
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Nom de l'entreprise</strong>
          <input
            v-model="companyNameValue"
            class="mts"
            type="text"
            name="CompanyName"
            maxlength="50"
          />
        </label>
      </div>
    </div>
    <div v-if="isAustralian" class="row">
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Phone Type</strong>
          <select v-model="phoneTypeValue" class="mts" name="PhoneType">
            <option value="">Choisir...</option>
            <option value="Mobile">Mobile</option>
            <option value="Landline">Landline</option>
          </select>
        </label>
        <div v-if="form.errors.phoneType" class="small-12">
          <ul
            v-for="(error, index) in form.errors.phoneType"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Date of Birth</strong>
          <input
            v-model="dateOfBirthValue"
            class="mts"
            type="date"
            name="DateOfBirth"
          />
        </label>
        <div v-if="form.errors.dateOfBirth" class="small-12">
          <ul
            v-for="(error, index) in form.errors.dateOfBirth"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="isAustralian" class="row">
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">
            ABN
            <img
              ref="js-abn-tooltip"
              class="has-tip top mls"
              data-tooltip
              aria-haspopup="true"
              data-allow-html="true"
              data-tooltip-class="tooltip"
              :src="questionIconUrl"
              alt="question mark icon"
              title="Your Australian Business Number (ABN). This is optional for individual designers but required for registered businesses."
            />
          </strong>
          <input
            v-model="abnValue"
            class="mts"
            type="text"
            name="Abn"
            maxlength="11"
            @input="abnValue = abnValue.replace(/\D/g, '')"
          />
        </label>
        <div v-if="form.errors.abn" class="small-12">
          <ul
            v-for="(error, index) in form.errors.abn"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">
            Registered Business Name
            <img
              ref="js-registered-business-name-tooltip"
              class="has-tip top mls"
              data-tooltip
              aria-haspopup="true"
              data-allow-html="true"
              data-tooltip-class="tooltip"
              :src="questionIconUrl"
              alt="question mark icon"
              title="The name your business is registered under, not the trading name. This is required for registered businesses."
            />
          </strong>
          <input
            v-model="registeredBusinessNameValue"
            class="mts"
            type="text"
            name="RegisteredBusinessName"
            maxlength="200"
            :disabled="entityTypeValue !== 'NonIndividual'"
          />
        </label>
        <div v-if="form.errors.registeredBusinessName" class="small-12">
          <ul
            v-for="(error, index) in form.errors.registeredBusinessName"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row column">
      <label>
        <strong class="text-black">
          Adresse
          <img
            v-if="isAustralian"
            ref="js-address-tooltip"
            class="has-tip top mls"
            data-tooltip
            aria-haspopup="true"
            data-allow-html="true"
            data-tooltip-class="tooltip"
            :src="questionIconUrl"
            alt="question mark icon"
            title="Your postal address. Do not include suburb, town, locality, state, postcode, or country in these two lines."
          />
        </strong>
        <input
          v-model="addressValue"
          class="mts"
          type="text"
          name="Address"
          maxlength="300"
        />
        <div v-if="form.errors.address" class="small-12">
          <ul
            v-for="(error, index) in form.errors.address"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
        <input
          v-model="addressLine2Value"
          class="mts"
          type="text"
          name="AddressLine2"
          maxlength="300"
        />
        <div v-if="form.errors.addressLine2" class="small-12">
          <ul
            v-for="(error, index) in form.errors.addressLine2"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </label>
    </div>
    <div class="row">
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Ville</strong>
          <input
            v-model="cityValue"
            class="mts"
            type="text"
            name="City"
            maxlength="50"
          />
        </label>
      </div>
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Etat</strong>
          <template v-if="isAustralian">
            <select v-model="stateValue" class="mts" name="State">
              <option value="">Choisir...</option>
              <option
                v-for="stateCode in australianStates"
                :key="stateCode"
                :value="stateCode"
              >
                {{ stateCode }}
              </option>
            </select>
          </template>
          <template v-else>
            <input
              v-model="stateValue"
              class="mts"
              type="text"
              name="State"
              maxlength="50"
            />
          </template>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Code postal</strong>
          <input
            v-model="postcodeValue"
            class="mts"
            type="text"
            name="Postcode"
            maxlength="50"
          />
        </label>
        <div v-if="form.errors.postcode" class="small-12">
          <ul
            v-for="(error, index) in form.errors.postcode"
            :key="index"
            class="text-color-red text-medium"
          >
            <li>{{ error }}</li>
          </ul>
        </div>
      </div>
      <div class="column small-12 medium-6">
        <label>
          <strong class="text-black">Pays</strong>
          <select v-model="countryValue" class="mts" name="Country">
            <option
              v-for="(countryName, index) in countries"
              :key="index"
              :value="countryName"
            >
              {{ countryName }}
            </option>
          </select>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <label class="mbm">
          <strong class="text-black">Statut du compte</strong>
          <span>
            {{ status }}
            (<a :href="deactivateUrl">Désactiver mon compte</a>)
          </span>
          <input type="hidden" name="portfolioUrl" :value="portfolioUrl" />
        </label>
      </div>
    </div>
    <div class="row">
      <div class="column text-center">
        <button class="button mbn" :disabled="form.disabled" @click="save">
          Modifier
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import Callout from '../../../shared/Callout/Callout.vue';

const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const australianStates = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];

function initialStateValue(country, state) {
  if (country !== 'Australia') return state || '';
  return australianStates.includes(state) ? state : '';
}
const validEntityTypes = ['Individual', 'NonIndividual'];
const validPhoneTypes = ['Mobile', 'Landline'];
const isBlank = (value) =>
  value === null || value === undefined || String(value).trim() === '';

const isInvalidDob = (value) => {
  if (isBlank(value)) return true;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return true;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return date < new Date('1900-01-01') || date > today;
};

const isInvalidPostcode = (value) => {
  if (isBlank(value)) return true;
  const str = String(value).trim();
  if (!/^\d{4}$/.test(str)) return true;
  const num = parseInt(str, 10);
  return num < 200 || num > 9999;
};

// Strips internal spaces to handle formatted input (e.g. "12 345 678 901")
const isInvalidAbn = (value) => {
  if (isBlank(value)) return true;
  return !/^\d{11}$/.test(String(value).replace(/\s/g, ''));
};

export default {
  components: { Callout },
  props: {
    address: {
      type: String,
      default: undefined,
    },
    addressLine2: {
      type: String,
      default: undefined,
    },
    city: {
      type: String,
      default: undefined,
    },
    companyName: {
      type: String,
      default: undefined,
    },
    country: {
      type: String,
      default: undefined,
    },
    dateOfBirth: {
      type: String,
      default: undefined,
    },
    email: {
      type: String,
      default: undefined,
    },
    firstName: {
      type: String,
      default: undefined,
    },
    lastName: {
      type: String,
      default: undefined,
    },
    phone: {
      type: String,
      default: undefined,
    },
    postcode: {
      type: String,
      default: undefined,
    },
    state: {
      type: String,
      default: undefined,
    },
    portfolioUrl: {
      type: String,
      default: undefined,
    },
    deactivateUrl: {
      type: String,
      default: undefined,
    },
    status: {
      type: String,
      default: undefined,
    },
    countries: {
      type: Array,
      default: () => [],
    },
    resetChangePasswordForm: {
      type: Boolean,
      default: true,
    },
    updateDetailsEndpoint: {
      type: String,
      required: true,
    },
    resendVerificationEmailEndpoint: {
      type: String,
      required: true,
    },
    entityType: {
      type: String,
      default: undefined,
    },
    phoneType: {
      type: String,
      default: undefined,
    },
    abn: {
      type: String,
      default: undefined,
    },
    registeredBusinessName: {
      type: String,
      default: undefined,
    },
    questionIconUrl: {
      type: String,
      default: '',
    },
    warningIconUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    const errorDefault = {
      profile: [],
      resendVerficationEmail: [],
    };
    return {
      australianStates,
      showPasswordWarning: false,
      isChangePasswordFormVisible: false,
      firstNameValue: this.firstName,
      lastNameValue: this.lastName,
      password: '',
      newPassword: '',
      confirmPassword: '',
      phoneValue: this.phone,
      companyNameValue: this.companyName,
      addressValue: this.address,
      addressLine2Value: this.addressLine2,
      cityValue: this.city,
      stateValue: initialStateValue(this.country, this.state),
      postcodeValue: this.postcode,
      countryValue: this.country,
      dateOfBirthValue: this.dateOfBirth,
      entityTypeValue: this.entityType || '',
      phoneTypeValue: this.phoneType || '',
      abnValue: this.abn || '',
      registeredBusinessNameValue: this.registeredBusinessName || '',
      verificationEmailReSent: false,
      form: {
        disabled: false,
        errorDefault,
        errors: errorDefault,
      },
    };
  },
  computed: {
    isAustralian() {
      return this.countryValue === 'Australia';
    },
    serrMissingFieldLabels() {
      if (this.entityTypeValue === 'Individual') {
        return [
          isBlank(this.firstNameValue) && 'Prénom',
          isBlank(this.lastNameValue) && 'Nom de famille',
          isInvalidDob(this.dateOfBirthValue) && 'Date of Birth',
          isBlank(this.phoneValue) && 'Téléphone',
          !validPhoneTypes.includes(this.phoneTypeValue) && 'Phone Type',
          isBlank(this.addressValue) && 'Adresse',
          isBlank(this.cityValue) && 'Ville',
          !australianStates.includes(this.stateValue) && 'Etat',
          isInvalidPostcode(this.postcodeValue) && 'Code postal',
          // ABN optional for individuals, but validate format if provided
          !isBlank(this.abnValue) && isInvalidAbn(this.abnValue) && 'ABN',
        ].filter(Boolean);
      }
      return [
        isInvalidAbn(this.abnValue) && 'ABN',
        isBlank(this.registeredBusinessNameValue) &&
          'Registered Business Name',
        isBlank(this.phoneValue) && 'Téléphone',
        !validPhoneTypes.includes(this.phoneTypeValue) && 'Phone Type',
        isBlank(this.addressValue) && 'Adresse',
        isBlank(this.cityValue) && 'Ville',
        !australianStates.includes(this.stateValue) && 'Etat',
        isInvalidPostcode(this.postcodeValue) && 'Code postal',
      ].filter(Boolean);
    },
    serrCallout() {
      if (!this.isAustralian) return null;
      if (!validEntityTypes.includes(this.entityTypeValue)) {
        return {
          title: 'Individual or business?',
          lead: 'As an Australian designer, you need to tell us whether you operate as an individual or a registered business so we can meet our ATO reporting obligations. Select your Entity Type below.',
          missingFieldLabels: [],
        };
      }
      const missingFieldLabels = this.serrMissingFieldLabels;
      if (missingFieldLabels.length === 0) return null;
      return {
        title: 'Your tax reporting details are incomplete',
        lead: 'We need a few more details to meet our ATO reporting obligations for Australian designers. Please complete the following:',
        missingFieldLabels,
      };
    },
  },
  watch: {
    resetChangePasswordForm(resetChangePasswordForm) {
      if (resetChangePasswordForm) {
        this.password = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.isChangePasswordFormVisible = false;
        this.showPasswordWarning = false;
      }
    },
    isAustralian(isNowAustralian) {
      if (isNowAustralian && !australianStates.includes(this.stateValue)) {
        this.stateValue = '';
      }
      if (!window.Foundation || !window.$) return;
      if (isNowAustralian) {
        this.$nextTick(() => {
          this.entityTypeTooltip = new window.Foundation.Tooltip(
            window.$(this.$refs['js-entity-type-tooltip']),
          );
          this.abnTooltip = new window.Foundation.Tooltip(
            window.$(this.$refs['js-abn-tooltip']),
          );
          this.registeredBusinessNameTooltip = new window.Foundation.Tooltip(
            window.$(this.$refs['js-registered-business-name-tooltip']),
          );
          this.addressTooltip = new window.Foundation.Tooltip(
            window.$(this.$refs['js-address-tooltip']),
          );
        });
      } else {
        if (this.entityTypeTooltip) {
          this.entityTypeTooltip.destroy();
          this.entityTypeTooltip = null;
        }
        if (this.abnTooltip) {
          this.abnTooltip.destroy();
          this.abnTooltip = null;
        }
        if (this.registeredBusinessNameTooltip) {
          this.registeredBusinessNameTooltip.destroy();
          this.registeredBusinessNameTooltip = null;
        }
        if (this.addressTooltip) {
          this.addressTooltip.destroy();
          this.addressTooltip = null;
        }
      }
    },
  },
  mounted() {
    if (window.Foundation && window.$) {
      if (this.isAustralian) {
        this.entityTypeTooltip = new window.Foundation.Tooltip(
          window.$(this.$refs['js-entity-type-tooltip']),
        );
        this.abnTooltip = new window.Foundation.Tooltip(
          window.$(this.$refs['js-abn-tooltip']),
        );
        this.registeredBusinessNameTooltip = new window.Foundation.Tooltip(
          window.$(this.$refs['js-registered-business-name-tooltip']),
        );
        this.addressTooltip = new window.Foundation.Tooltip(
          window.$(this.$refs['js-address-tooltip']),
        );
      }
    }
  },
  methods: {
    showChangePasswordForm() {
      this.isChangePasswordFormVisible = true;
    },
    hideChangePasswordForm() {
      this.isChangePasswordFormVisible = false;
    },
    onSubmitUpdatePasswordForm(e) {
      e.preventDefault();

      if (this.newPassword !== this.confirmPassword) {
        this.showPasswordWarning = true;
        return;
      }

      this.$emit('update-password', {
        password: this.password,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
      });
    },
    async save() {
      this.form.disabled = true;

      const data = {
        FirstName: this.firstNameValue,
        LastName: this.lastNameValue,
        Phone: this.phoneValue,
        CompanyName: this.companyNameValue,
        Address: this.addressValue,
        AddressLine2: this.addressLine2Value,
        City: this.cityValue,
        State: this.stateValue,
        Postcode: this.postcodeValue,
        Country: this.countryValue,
        ...(this.isAustralian && {
          DateOfBirth: this.dateOfBirthValue,
          EntityType: this.entityTypeValue,
          PhoneType: this.phoneTypeValue,
          Abn: this.abnValue,
          RegisteredBusinessName: this.registeredBusinessNameValue,
        }),
      };

      const res = await axios.post(
        this.updateDetailsEndpoint,
        data,
        axiosConfig,
      );
      this.form.errors = { ...this.form.errorDefault, ...res.data.errors };

      if (res.data.errors) {
        this.$emit('show-api-success-message', null);
      } else if (res.data.errorMessage) {
        this.$emit('show-api-success-message', null);
        this.$emit('show-api-error-messages', [res.data.errorMessage]);
      } else {
        this.$emit('show-api-success-message', res.data.successMessage);
      }
      this.form.disabled = false;
    },
    async resendVerificationEmail() {
      this.verificationEmailReSent = true;
      const res = await axios.post(
        this.resendVerificationEmailEndpoint,
        null,
        axiosConfig,
      );
      this.form.errors = { ...this.form.errorDefault, ...res.data.errors };

      if (res.data.errors) {
        this.$emit('show-api-success-message', null);
        this.verificationEmailReSent = false;
      } else if (res.data.errorMessage) {
        this.$emit('show-api-success-message', null);
        this.$emit('show-api-error-messages', [res.data.errorMessage]);
        this.verificationEmailReSent = false;
      } else {
        this.$emit('show-api-success-message', res.data.successMessage);
      }
    },
  },
};
</script>
